
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../../components/Footer'
import Mainmenu from '../../components/Mainmenu'
import Navbar from '../../components/Navbar'
import { getDefaultName } from '../../utils'
import { HttpService } from '../../utils/http'
import {ApiHttpService} from '../../utils/http/api'

function Polls() {
    const [loading, setLoading] = useState(0);
  const [pageloading, setPageLoading] = useState(false);
  const [polls, setPolls] = useState(null);
  const [polls_count, setPollsCount] = useState(null);
  const [show_delete, setShowDelete] = useState(false);
  const [pages, setPages] = useState(null);

  var urlParams = ""
  var page =1 

  useEffect(() => {
    setPageLoading(true);
    getData();

    
  }, []);

  function getData() {
    //console.log(filter_query)
    ApiHttpService.loadPolls(page).then((data) => {
      if (data.results) {
        setPolls(data.results);
      }
      const totalCount = Number(data.count) || 0;
      setPollsCount(totalCount);
      if (data.count) {
        if (data && data.count) {
          var page_count =
            data.count % 10 === 0
              ? parseInt(data.count / 10)
              : parseInt(data.count / 10) + 1;
          var pages_array = range(1, page_count);
          setPages(pages_array);
        }
      }
      setPageLoading(false);
    });
  }
  function range(start, end) {
    return Array.apply(0, Array(end)).map((element, index) => index + start);
  }

  const handleDelete = (id, e) => {
    setLoading(id);
    var service = new HttpService();
    service.delete(`api/poll/${id}`).then(()=>{
        setLoading(false);
        setPolls(polls.filter(item=>item.id!=id))
    })
   
  };

  const showDelete = (e) => {
    e.preventDefault();
    setShowDelete(!show_delete);
  };

  return (
    <div class="wrapper">
        <Navbar />
        <Mainmenu />
        <div className="content-wrapper">
            <section class="content-header">
            <h3 class="box-title mt-5"></h3>
            <ol class="breadcrumb">
                <li>
                <a href="dashboard">
                    <i class="fa fa-dashboard"></i> Home
                </a>
                </li>
                <li class="active">Polls</li>
            </ol>
            </section>

            <section className="content">
            <div className="container-fluid">
                <div className="row users-filter-page-row">
                <div className="col-md-12 users-filter-page-col">
                <div className="box box-primary">
                    <div className="box-header with-border">
                    <h3 className="box-title">
                        All polls
                        {polls_count != null && (
                            <span style={{ fontSize: 11, marginLeft: '0.35em' }}>
                                ({polls_count})
                            </span>
                        )}
                    </h3>
                    <a href="/cms/poll" title="Add New" className="btn btn-cm margin-r-5 pull-right">
                        <i className="fa fa-plus"></i>
                    </a>
                    <button
                        type="button"
                        title="Show Delete Button"
                        className="btn btn-cm margin-r-5 pull-right"
                        onClick={showDelete}
                    >
                        <i className="fa fa-trash"></i>
                    </button>
                    </div>
                    <div className="box-body no-padding">
                    <form action="" method="get">
                        <table
                            id="example1"
                            className={`table table-striped cms-list-table mb-0${pageloading ? ' opacity-70' : ''}`}
                        >
                        <thead>
                            <tr>
                            <th>Name</th>
                            <th>Date</th>
                            <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {polls?.map((item) => (
                            <tr
                                key={item.id}
                                className={loading === item.id ? "loading" : ""}
                            >
                                <td>
                                    <a href={`/cms/poll/${item.id}`}>
                                        {getDefaultName(item.names)}
                                    </a>
                                </td>
                                <td>
                                    {item.created_at.split("T")[0]}
                                    <br />
                                    {item.created_at.split("T")[1].split(".")[0]}
                                </td>
                                <td>
                                <div className="btn-group">
                                    {show_delete && (
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                        if (
                                            window.confirm(
                                            "Are you sure you wish to delete this item?"
                                            )
                                        )
                                            handleDelete(item.id, e);
                                        }}
                                        className="btn btn-cm"
                                    >
                                        <i className="fa fa-trash"></i>
                                    </button>
                                    )}
                                    <a href={`/cms/poll/report/${item.id}`} title="Poll results" className="btn btn-cm ">
                                        <i className="fa fa-bar-chart"></i>
                                    </a>
                                </div>
                                </td>
                            </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                            <th>Name</th>
                            <th>Date</th>
                            <th></th>
                            </tr>
                        </tfoot>
                        </table>
                    </form>
                    </div>
                </div>

                {pages && pages.length > 1 && (
                <ul className="pagination cms-pagination m-0 float-right">
                    <li className="page-item">
                    <Link className="page-link" to="#">
                        «
                    </Link>
                    </li>
                    {pages.map((page_number) => (
                        <li key={page_number} className="page-item">
                        <a
                            className={
                            page_number == page ? "page-link active" : "page-link"
                            }
                            href={`emails/${page_number}${
                            urlParams ? "?" + urlParams : ""
                            }`}
                        >
                            {page_number}
                        </a>
                        </li>
                    ))}
                    <li className="page-item">
                    <Link className="page-link" to="">
                        »
                    </Link>
                    </li>
                </ul>
                )}
                </div>
                </div>
            </div>
            </section>
        </div>
        <Footer />

    </div>
  )
}

export default Polls
